import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpInterceptorService, RESTService } from '@covalent/http-deprec';

import { UserInfo } from './Model/UserInfo';
import { environment } from '../../../../environments/environment';
import {catchError, map} from "rxjs/operators";
import {throwError} from "rxjs/index";


@Injectable()
export class BenutzerService extends RESTService<UserInfo[]> {

  constructor(
    public http: HttpInterceptorService
  ) {
    super(http, {
      baseUrl: `${environment.apiHost}`,
      path: 'makpak/getalluserinfo'
    });
  }

  getAllUsers(): Observable<UserInfo[]> {
    console.log("alle User aus DB-Tabelle BENUTZER auslesen !");
    return super.get("").pipe(
      map((res: UserInfo[]) => {
        return res;
      }));
  }


  deleteUser(benutzerId : string) : Observable<boolean> {
    return this.http.delete(`${environment.apiHost}` + '/makpak/userdelete/' + benutzerId).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((result: boolean) => {
        console.log("User gelöscht ");
        if (result != null) {
          return result;
        }
        console.log(result);
      }));
  }

  updateUser(userinfo : UserInfo) : Observable<UserInfo> {
    return this.http.post(`${environment.apiHost}` + '/makpak/userupdate', userinfo).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("User angelegt / aktualisiert");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  postMeinKonto(meinkonto : any) : Observable<any> {
    return this.http.post(`${environment.apiHost}` + '/makpak/meinkontoupdate', meinkonto).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("mein Konto aktualisiert");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  getMeinKonto() : Observable<any> {
    return this.http.get(`${environment.apiHost}` + '/makpak/meinkontoleg').pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("User angelegt / aktualisiert");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  getAllVtnrs() : Observable<any> {
    return this.http.get(`${environment.apiHost}` + '/makpak/meinkonto/vtnrs').pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("Vtnrs zu Bensl geholt");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  async getVtnrAdress(vtnr: any) : Promise<any> {
    const response = await this.http.get(`${environment.apiHost}` + '/makpak/meinkonto/vtnrAdress?vtnr=' + vtnr).toPromise();
     return response.json();
  }

  getSystemRoles() : Observable<any> {
    return this.http.get(`${environment.apiHost}` + '/makpak/meinkonto/systemRoles').pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("System Roles wurden ausgelesen");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  checkRequestId() : Observable<any> {
    return this.http.get(`${environment.apiHost}` + '/makpak/meinkontorequest').pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  checkVtnr(vermittlernr : any, plz: any) : Observable<any> {
    let formData: FormData = new FormData();
    formData.append("vermittlernr", vermittlernr);
    formData.append("plz", plz);
    return this.http.post(`${environment.apiHost}` + '/makpak/meinkonto/vermittlernummer', formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("vermittlernummert");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  postSendeNewRoles(berechtigungen : any, vermittlernr: any, deletedberechtigungen:any) : Observable<any> {
    let formData: FormData = new FormData();
    formData.append("berechtigungen", berechtigungen);
    formData.append("vermittlernr", vermittlernr);
    formData.append("deletedberechtigungen", deletedberechtigungen);
    return this.http.post(`${environment.apiHost}` + '/makpak/meinkonto/absenden', formData).pipe(
      map(res => res.json()),
      catchError(error => throwError(error)),
      map((res: UserInfo) => {
        console.log("mein Konto aktualisiert");
        if (res != null) {
          return res;
        }
        console.log(res);
      }));
  }

  async postGenehmiger(berechtigungen : any, vermittlernr: any, deletedberechtigungen:any) : Promise<any> {
    let formData: FormData = new FormData();
    formData.append("berechtigungen", berechtigungen);
    formData.append("vermittlernr", vermittlernr);
    formData.append("deletedberechtigungen", deletedberechtigungen);
    const res = await this.http.post(`${environment.apiHost}` + '/makpak/meinkonto/msn', formData).toPromise();
    return res;
  }
}
